<template>
    <div>
        <div>
            <el-form :model="queryForm" :inline="true"  style="text-align:left;" label-width="100px" class="queryform-class">
                <el-row>
                    <el-col :span="9">
                        <el-form-item label="延保产品名称:" class="prod-select">
                            <My-Select v-model="queryForm.prodCode" :objSelect="queryForm.prodCode" :options="ewProductList" :placeholder="ewPlaceholder"
                                :optionBind="optionBindEw"  @changeSelct="changeEwSelct" :clearable='true'></My-Select>                
                        </el-form-item>
                    </el-col>
                    <el-col  :span="8">
                        <el-form-item label="承销商:" class="agent-select">
                            <My-Select v-model="queryForm.agentCode" :objSelect="queryForm.agentCode" :options="agentList" :placeholder="agentPlaceholder"
                                    :optionBind="optionBindAgent" @changeSelct="changeAgent" :clearable='true'></My-Select>                
                        </el-form-item>
                    </el-col>
                    <el-col :span="7">
                        <el-form-item label="销售人员类型:" class="agent-select">
                            <el-select v-model="queryForm.salesLevel" clearable placeholder="请选择销售人员类型">
                                <el-option
                                    v-for="(item,index) in salesLevelList"
                                    :key="index"
                                    :label="item.label"
                                    :value="item.value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    
                </el-row>
                <el-row>
                    <el-col :span="9">
                        <el-form-item label="审核通过时间:" class="datatime-class">
                            <el-date-picker
                                v-model="queryForm.passTimeStart"
                                type="datetime"
                                placeholder="开始时间" value-format="yyyy-MM-dd HH:mm:ss">
                            </el-date-picker>
                            <span> - </span>   
                            <el-date-picker
                                v-model="queryForm.passTimeEnd"
                                type="datetime"
                                default-time = "23:59:59"
                                placeholder="结束时间" value-format="yyyy-MM-dd HH:mm:ss">
                            </el-date-picker>        
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="品类:" class="agent-select">
                            <My-Select v-model="queryForm.dicTypeCode" :objSelect="queryForm.dicTypeCode" :options="categoryList" :placeholder="categoryPlaceholder"
                            :optionBind="optionBindCategory"  @changeSelct="changeCategorySelct" :clearable='true'></My-Select>                 
                        </el-form-item>
                    </el-col>
                    <el-col :span="7">                      
                        <el-button type="primary" plain @click="query()">查询</el-button>
                        <el-button type="primary" plain  @click="exportExt()">导出</el-button> 
                    </el-col>                    
                </el-row>
            </el-form>
        </div>
        <div>
            <My-table :configurationData="configurationData" :operation="operation" :getTableParam="getTableParam" ref="myTable"></My-table>
        </div>          
    </div>
</template>

<script>
import  asyncApi   from '../../api/asyncApi';
export default { 
    name: 'salesBills',
    data(){
        return{
            agentPlaceholder:'请选择承销商名称',
            categoryPlaceholder:'请选择品类',
            ewPlaceholder:'请选择延保产品',  
            ewProductList:[], 
            categoryList:[],  
            agentList:[], 
            salesLevelList:[
                {value:'1',label:'一级销售'},
                {value:'2',label:'二级销售'},
                {value:'3',label:'三级销售'}
            ],          
            queryForm:{
                passTimeStart:'',
                passTimeEnd:'',
                // prodName:'',
                prodCode: '',
                agentCode:'',
                dicTypeCode:'',
                salesLevel:''
            },
            optionBindEw:{
                label:"prodName",
                value:"prodCode"
            },
            optionBindCategory:{
                label:"dicTypeName",
                value:"dicTypeCode"
            },
            optionBindAgent:{
                label:"agentName",
                value:"agentCode"
            },
             // 列表配置
            configurationData:[
                {
                    title: '人员类型',
                    propertys: 'userType',
                    width: '',
                    format:this.formatUserType
                },
                {
                    title: '人员名称',
                    propertys: 'userName',
                    width: ''
                },
                // {
                //     title: '延保产品名称',
                //     propertys: 'prodName',
                //     width: ''
                // },
                // {
                //     title: '品类',
                //     propertys: 'dicTypeName',
                //     width: ''
                // },
                // {
                //     title: '延保销售价格(元)',
                //     propertys: 'price',
                //     width: ''
                // },
                {
                    title: '佣金金额(元)',
                    propertys: 'commissionMoney',
                    width: ''
                },
                {
                    title: '身份证号',
                    propertys: 'idCard',
                    width: ''
                },
                {
                    title: '开户行',
                    propertys: 'bank',
                    width: ''
                },
                {
                    title: '银行卡号',
                    propertys: 'bankCard',
                    width: ''
                }
            ],
             // 是否有操作按钮 宽度
            operation: {
                show: false,
                width: ''
            },
            getTableParam:{
                url:'/extwarapi/api/statistic/getSalesBill',
                param:''
            }
        }
    },
    methods:{
        formatUserType(row){
            if(row.userType=='1'){
			    return '一级销售'
            }else if(row.userType=='2'){
                return '二级销售'
            }else if(row.userType=='3'){
                return '三级销售'
            }
        },
        query(){
            this.getTableParam.param=this.queryForm;
            this.$refs["myTable"].query(1);
        },
        changeEwSelct(value){
            // console.log('changeEW',value)
            // this.queryForm.prodName=value;
            this.queryForm.prodCode=value
        },
        changeCategorySelct(value){
            this.queryForm.dicTypeCode=value;
        },
        changeAgent(value){
            this.queryForm.agentCode=value;             
        },
        //获取延保产品字典
        async getEwProduct(){
            let url ="/extwarapi/api/extension/getProdEnum";
            let data = await asyncApi.post(url,{code:''});  
            if(data.code=='0000'){
                this.ewProductList=data.result;
                // console.log('ewprod',this.ewProductLists)
            } 
        },
        //获取承销商数据字典
        async getAgentList(){
            let url ="/extwarapi/api/agent/getAgentEnum";
            let data = await asyncApi.post(url,null);  
            if(data.code=='0000'){
                this.agentList=data.result;
            }
        },
        //获取品类产品字典
        async getCategory(){
            let url ="/extwarapi/api/dicProdType/getTypeEnum";
            let data = await asyncApi.post(url,null);  
            if(data.code=='0000'){
                this.categoryList=data.result;
            }
        },
        exportExt(){
            let url="/extwarapi/api/statistic/getSalesBillExport";
            let param=Object.assign({},this.queryForm);
                param.pageNum=1;
                param.pageSize=9999;
            this.axios.post(url, param,{responseType: "blob"}).then((resp) => {               
                let fileName=decodeURIComponent(resp.headers["content-disposition"]).split('=')[1];
                let blob = new Blob([resp.data], { type: ".xlsx" });
                if (window.navigator.msSaveOrOpenBlob) {
                    navigator.msSaveBlob(blob,fileName);
                } else {
                    let a = document.createElement("a");
                    a.download = fileName;
                    a.href = window.URL.createObjectURL(blob);
                    a.click();
                    //释放内存
                     window.URL.revokeObjectURL(a.href)
                }
            }).catch((resp) => {
            //   console.log('error', resp); 
            })
        }
    },
    mounted(){
        this.getEwProduct();
        this.getAgentList();
        this.getCategory();
    }
 
}
</script>
<style lang="scss" >
.queryform-class {     
    .datatime-class .el-date-editor {
        width: 190px
    };
    .prod-select .el-input__inner{
        width: 292px;
    }
    .agent-select  .el-input__inner{
        width: 190px;
    }
}
</style>